
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IAppConfig } from '../models/app-config.model';

@Injectable()


export class AppConfigService {
    static settings: IAppConfig;
    constructor(private http: HttpClient) { }


    LoadAppConfig() {

        return new Observable((subscriber) => {
            try {


               // console.log("LoadAppConfig");
                console.trace();
                const timestamp = new Date().getTime();
                const jsonFile = `/assets/config/app.config.json?t=${timestamp}`;
                // HTTP Get call 
                //console.info(`AppConfigService :: app config : ${jsonFile}`);
                this.http.get<IAppConfig>(jsonFile).subscribe({
                    next: (data: IAppConfig) => {
                       // console.info('AppConfigService :: app config loaded successfull');
                        AppConfigService.settings = <IAppConfig>data;
                       // console.log(`AppConfigService :: configuration :${JSON.stringify(AppConfigService.settings)}`)
                        subscriber.next();
                    }, error: (e) => {
                       // console.log(`AppConfigService :: config load error :${JSON.stringify(e)}`)
                        subscriber.error(e);
                    },
                    complete: () => {
                      //  console.log(`AppConfigService :: config load complete`)
                        subscriber.complete();
                    }
                });
            } catch (e: any) {
                //console.log("RemoteLoaderService :: LoadMicroAppsConfiguration :: error : " + e.message);
                subscriber.error();
            }

        });
    }

}